import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryCardComponent } from './category-card.component';
import { CategoryCard } from '../../core/models/interfaces-general';

@Component({
    selector: 'app-category-carousel-section',
    standalone: true,
    imports: [CommonModule, CategoryCardComponent],
    template: `
    <section class="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-8">
      
      <!-- TÍTULO PRINCIPAL DE LA SECCIÓN -->
      <h2 
        *ngIf="title"
        class="text-lg sm:text-xl md:text-2xl  tracking-tight w-full mb-6"
        style="color: var(--text-accent);"
      >
        {{ title }}
      </h2>

      <!-- ESTRUCTURA PRINCIPAL: En móvil stackea vertical, en escritorio se divide 1:3 -->
      <div [class]="(titleSide || description) ? 'grid grid-cols-1 md:grid-cols-[260px_1fr] lg:grid-cols-[1fr_3fr] gap-6 lg:gap-8 items-center' : 'w-full'">
        
        <!-- BLOQUE LATERAL / SUPERIOR EN MÓVIL (Ocupa menos de 1/3 en escritorio) -->
        <div 
          *ngIf="titleSide || description"
          class="flex flex-col justify-center items-center md:items-start text-center md:text-left pr-0 md:pr-4"
        >
          <p 
            *ngIf="titleSide" 
            class="font-bold text-lg sm:text-xl leading-snug mb-2" 
            style="color: var(--bg-main);"
          >
            {{ titleSide }}
          </p>
          <p *ngIf="description" class="text-sm sm:text-base text-gray-600 leading-relaxed">
            {{ description }}
          </p>
        </div>

        <!-- CONTENEDOR DEL CARRUSEL DE CATEGORÍAS -->
        <div class="relative min-w-0">
          
          <!-- Contenedor con Scroll Horizontal (Deslizable en Móviles) -->
          <div 
            #scrollContainer
            class="flex gap-4 sm:gap-6 overflow-x-auto scrollbar-hide scroll-smooth py-4 px-1"
          >
            <div 
              *ngFor="let category of categories" 
              class="w-[220px] sm:w-[250px] lg:w-[270px] flex-shrink-0"
            >
              <app-category-card [item]="category"></app-category-card>
            </div>
          </div>

          <!-- FLECHAS DE NAVEGACIÓN INFERIORES -->
          <div class="flex justify-end items-center gap-3 mt-4 pr-2">
            <!-- Flecha Izquierda -->
            <button 
              (click)="scrollLeft()"
              class="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 active:scale-95 transition-all border border-gray-100 cursor-pointer"
              aria-label="Anterior"
            >
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <!-- Flecha Derecha -->
            <button 
              (click)="scrollRight()"
              class="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 active:scale-95 transition-all border border-gray-100 cursor-pointer"
              aria-label="Siguiente"
            >
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

        </div>

      </div>

    </section>
  `,
    styles: [`
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    .scrollbar-hide {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  `]
})
export class CategoryCarouselSectionComponent {
    @Input({ required: false }) title: string = '';
    @Input({ required: false }) titleSide: string = '';
    @Input({ required: false }) description: string = '';

    @Input({ required: true }) categories: CategoryCard[] = [];

    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

    scrollLeft() {
        this.scrollContainer.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
    }

    scrollRight() {
        this.scrollContainer.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
    }
}